var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteGeometryCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.26875 0 0 6.26875 0 14C0 21.7313 6.26875 28 14 28C21.7313 28 28 21.7313 28 14C28 6.26875 21.7313 0 14 0ZM19.1688 19.3188L17.1063 19.3094L14 15.6063L10.8969 19.3062L8.83125 19.3156C8.69375 19.3156 8.58125 19.2062 8.58125 19.0656C8.58125 19.0062 8.60312 18.95 8.64062 18.9031L12.7063 14.0594L8.64062 9.21875C8.60286 9.17295 8.58191 9.11561 8.58125 9.05625C8.58125 8.91875 8.69375 8.80625 8.83125 8.80625L10.8969 8.81563L14 12.5188L17.1031 8.81875L19.1656 8.80937C19.3031 8.80937 19.4156 8.91875 19.4156 9.05937C19.4156 9.11875 19.3938 9.175 19.3563 9.22188L15.2969 14.0625L19.3594 18.9062C19.3969 18.9531 19.4188 19.0094 19.4188 19.0688C19.4188 19.2063 19.3063 19.3188 19.1688 19.3188Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGeometryCircle);
export default __webpack_public_path__ + "static/media/delete-geometry-circle.7159dda45dc947de55ee6010fda670a5.svg";
export { ForwardRef as ReactComponent };